var _a;
import { configureStore } from "@reduxjs/toolkit";
import { enhancedApi } from "./enhancedApi";
import profileReducer from "./slices/profileSlice";
import viewportReducer from "./slices/viewportSlice";
export var store = configureStore({
    reducer: (_a = {
            authUser: profileReducer,
            appViewport: viewportReducer
        },
        _a[enhancedApi.reducerPath] = enhancedApi.reducer,
        _a),
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware().concat(enhancedApi.middleware);
    },
});
